import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotificationSmsPreviewTID = (parentTestId)=>getTestIds(parentTestId);
